/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumDateiUpload: {
    name: 'big-medium-datei-upload';
    data: string;
} = {
    name: 'big-medium-datei-upload',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M22.41 57.66 59 21.07v78.19a5 5 0 0 0 10 0V21.07l36.59 36.59a5 5 0 0 0 7.07-7.07L67.54 5.47a5.3 5.3 0 0 0-.77-.63c-.12-.08-.25-.13-.37-.2a5 5 0 0 0-.49-.26 4 4 0 0 0-.5-.15A3 3 0 0 0 65 4.1a5 5 0 0 0-2 0 3 3 0 0 0-.43.13 4 4 0 0 0-.5.15 5 5 0 0 0-.49.26c-.12.07-.25.12-.37.2a5.3 5.3 0 0 0-.77.63l-45.1 45.12a5 5 0 0 0 7.07 7.07m98 56.34H7.59a5 5 0 0 0 0 10h112.82a5 5 0 0 0 0-10"/></svg>`,
};
